import React from 'react';
import Link from 'gatsby-link';
import Widget from './Widget';

const WidgetHireMe = () => (
  <Widget>
    <h3 className="widget-title">I am currently available for new work</h3>
    <div className="widget-content">
      <p>Want to hire me for your next project?</p>
      <p>Have a web or software project you want to chat about?</p>
      <p>
        Reach out through{' '}
        <Link to="/contact" title="Contact page">
          my contact page
        </Link>{' '}
        and let&apos;s talk.
      </p>
    </div>
  </Widget>
);

export default WidgetHireMe;



// WEBPACK FOOTER //
// ./src/components/WidgetHireMe.js